<template>
  <v-card class="elevation-0">
    <v-card-text>
      <v-form ref="personalForm">
        <v-container fluid grid-list-sm class="pa-0">
          <v-layout row wrap>
            <v-flex md3 order-md2>
              <profile-pic-card></profile-pic-card>
            </v-flex>
            <v-flex md9>
              <v-container fluid>
                <v-layout row wrap>
                  <!-- line 1 -->
                  <v-flex md2 sm12>
                    <v-select
                    :items="items"
                    v-model="user.gender"
                    label="Title"
                    :box="editMode"
                    :required="editMode" :readonly="!editMode"
                    :rules="rules.isRequired"
                    ></v-select>
                  </v-flex>
                  <v-flex md4 sm12>
                    <v-text-field name="firstName" label="First Name" value="Input text" v-model="user.firstName" :rules="rules.firstName" :box="editMode" :required="editMode" :readonly="!editMode"></v-text-field>
                  </v-flex>
                  <v-flex md3 sm12>
                    <v-text-field name="middleName" label="Middle Name" maxlength="50" value="Input text" v-model="user.middleName" :rules="rules.middleName" :box="editMode"></v-text-field>
                  </v-flex>
                  <v-flex md3 sm12>
                    <v-text-field name="lastName" label="Last Name" maxlength="50" value="Input text" v-model="user.lastName" :box="editMode" :rules="rules.lastName" :required="editMode" :readonly="!editMode"></v-text-field>
                  </v-flex>
                  <!-- line 2 -->
                  <v-flex md4 sm12>
                    <v-text-field name="email" type="email" label="Email" value="Input text" v-model="user.email" readonly></v-text-field>
                  </v-flex>
                  <v-flex md1 sm2>
                    <v-text-field value="+91" readonly label="Mobile"></v-text-field>
                  </v-flex>
                  <v-flex md3 sm10>
                    <v-text-field name="phone" type="text" v-model="user.phone" :box="editMode" maxlength="10" mask="##########" :required="editMode" :readonly="!editMode" :rules="rules.isRequired"></v-text-field>
                  </v-flex>
                  <v-flex md4 sm12>
                    <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      v-model="dobMenu"
                      lazy
                      transition="scale-transition"
                      full-width
                      min-width="290px"
                      :disabled="!editMode"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="user.dob"
                        label="Date of birth"
                        :required="editMode" readonly
                        :rules="rules.isRequired"
                        :box="editMode"
                      ></v-text-field>
                      <v-date-picker
                        ref="picker"
                        v-model="user.dob"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1930-01-01"
                        @change="dobSave"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <!-- line 3 -->
                  <v-flex md6 sm12>
                    <v-text-field name="pan" type="text" label="PAN (optional)" :counter="10" :rules="rules.pan" mask="AAAAA####A"
                    v-model="kyc.pan.govtIdNumber" :box="editMode" :readonly="!editMode"></v-text-field>
                  </v-flex>
                  <v-flex md6 sm12>
                    <v-text-field name="aadhar" type="text" label="Aadhar (optional)" :counter="12" :rules="rules.aadhar" mask="############"
                    v-model="kyc.aadhar.govtIdNumber" :box="editMode" :readonly="!editMode"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-subheader class="primary--text pa-0">*PAN and Aadhar information will be kept confidential.</v-subheader>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="px-4">
            <v-flex md12>
              <span class="heading primary--text">Current Address*:</span>
            </v-flex>
            <v-flex md2>
              <v-text-field name="currentAddressDoorNumber" type="text" label="House No." v-model="user.currentAddressDoorNumber" :box="editMode" :required="editMode" :readonly="!editMode" :rules="rules.currentAddressDoorNumber"></v-text-field>
            </v-flex>
            <v-flex md6>
              <v-text-field name="currentAddressStreet" type="text" label="Street" v-model="user.currentAddressStreet" :box="editMode" :required="editMode" :readonly="!editMode" :rules="rules.currentAddressStreet"></v-text-field>
            </v-flex>
            <v-flex md4>
              <v-text-field name="currentAddressCity" type="text" label="City" v-model="user.currentAddressCity" :box="editMode" :required="editMode" :readonly="!editMode" :rules="rules.currentAddressCity"></v-text-field>
            </v-flex>
            <v-flex md4>
              <v-text-field name="currentAddressState" type="text" label="State" v-model="user.currentAddressState" :box="editMode" :required="editMode" :readonly="!editMode" :rules="rules.currentAddressState"></v-text-field>
            </v-flex>
            <v-flex md4>
              <v-text-field name="currentCountryName" type="text" label="Country"
              v-model="user.currentCountryName" :box="editMode" :required="editMode" :readonly="!editMode" :rules="rules.currentCountryName"></v-text-field>
            </v-flex>
            <v-flex md4>
              <v-text-field name="currentAddressPin" type="text" label="PIN" mask="######"
              v-model="user.currentAddressPin" :box="editMode" :required="editMode" :readonly="!editMode" :rules="rules.isRequired"></v-text-field>
            </v-flex>
            <v-switch
            :label="`Permanent address same as current address? ${permanentSameAsCurrentAddress?'YES':'NO'}`" color="primary" v-model="permanentSameAsCurrentAddress" light></v-switch>
            <template v-if="!permanentSameAsCurrentAddress">
              <v-flex xs12 class="my-4">
                <span class="heading primary--text">Permanent Address*:</span>
              </v-flex>
              <v-flex md2>
                <v-text-field name="permanentAddressDoorNumber" type="text" label="House No." v-model="user.permanentAddressDoorNumber" :box="editMode" :required="editMode" :readonly="!editMode" :rules="rules.permanentAddressDoorNumber"></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field name="permanentAddressStreet" type="text" label="Street" v-model="user.permanentAddressStreet" :box="editMode" :required="editMode" :readonly="!editMode" :rules="rules.permanentAddressStreet"></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-text-field name="permanentAddressCity" type="text" label="City" v-model="user.permanentAddressCity" :box="editMode" :required="editMode" :readonly="!editMode" :rules="rules.permanentAddressCity"></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-text-field name="permanentAddressState" type="text" label="State" v-model="user.permanentAddressState" :box="editMode" :required="editMode" :readonly="!editMode" :rules="rules.permanentAddressState"></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-text-field name="permanentCountryName" type="text" label="Country"
                v-model="user.permanentCountryName" :box="editMode" :required="editMode" :readonly="!editMode" :rules="rules.permanentCountryName"></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-text-field name="permanentAddressPin" type="text" label="PIN" mask="######"
                v-model="user.permanentAddressPin" :box="editMode" :required="editMode" :readonly="!editMode" :rules="rules.isRequired"></v-text-field>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
/* globals Store */
import { mapState } from 'vuex'
import ProfilePicCard from '@/components/ProfilePicCard'
export default {
  name: 'PersonalForm',
  props: ['save', 'editMode'],
  components: {
    ProfilePicCard
  },
  mounted () {
    if (Store.state.user.completion > 7 && Store.state.user.completion < 75) {
      Store.dispatch('user/getKyc')
    }
    if (this.user.permanentAddressDoorNumber !== '' && this.user.permanentAddressDoorNumber !== null) {
      this.permanentSameAsCurrentAddress = false
    }
  },
  data () {
    return {
      title: 'Personal Information',
      dobMenu: false,
      permanentSameAsCurrentAddress: true,
      rules: {
        isRequired: [
          (v) => !!v || 'Required'
        ],
        firstName: [
          (v) => !!v || 'First Name is empty',
          (v) => (v && v.length <= 20) || 'First Name must be less than 20 characters'
        ],
        middleName: [
          (v) => (v === null || v.length <= 20) || 'Middle Name must be less than 20 characters'
        ],
        lastName: [
          (v) => !!v || 'Last Name is empty',
          (v) => (v && v.length <= 20) || 'Last Name must be less than 20 characters'
        ],
        currentAddressDoorNumber: [
          (v) => !!v || 'Current address door number is empty',
          (v) => (v && v.length <= 20) || 'Current address door number must be less than 20 characters'
        ],
        currentAddressStreet: [
          (v) => !!v || 'Current address street is empty',
          (v) => (v && v.length <= 32) || 'Current address street must be less than 32 characters'
        ],
        currentAddressCity: [
          (v) => !!v || 'Current address city is empty',
          (v) => (v && v.length <= 32) || 'Current address city must be less than 32 characters'
        ],
        currentAddressState: [
          (v) => !!v || 'Current address state is empty',
          (v) => (v && v.length <= 32) || 'Current address state must be less than 32 characters'
        ],
        currentCountryName: [
          (v) => !!v || 'Current country name is empty',
          (v) => (v && v.length <= 32) || 'Current country name must be less than 32 characters'
        ],
        permanentAddressDoorNumber: [
          (v) => !!v || 'Permanent address door number is empty',
          (v) => (v && v.length <= 16) || 'Permanent address door number must be less than 16 characters'
        ],
        permanentAddressStreet: [
          (v) => !!v || 'Permanent address street is empty',
          (v) => (v && v.length <= 32) || 'Permanent address street must be less than 32 characters'
        ],
        permanentAddressCity: [
          (v) => !!v || 'Permanent address city is empty',
          (v) => (v && v.length <= 32) || 'Permanent address city must be less than 32 characters'
        ],
        permanentAddressState: [
          (v) => !!v || 'Permanent address state is empty',
          (v) => (v && v.length <= 32) || 'Permanent address state must be less than 32 characters'
        ],
        permanentCountryName: [
          (v) => !!v || 'Permanent country name is empty',
          (v) => (v && v.length <= 32) || 'Permanent country name must be less than 32 characters'
        ],
        pan: [
          (v) => (v.length === 0 || v.length === 10) || 'PAN must be of 10 characters'
        ],
        aadhar: [
          (v) => (v.length === 0 || v.length === 12) || 'Aadhar must be of 12 characters'
        ]
      },
      items: [
        {
          text: 'Mr.',
          value: 'mr'
        },
        {
          text: 'Mrs.',
          value: 'mrs'
        },
        {
          text: 'Ms.',
          value: 'ms'
        },
        {
          text: 'Mx.',
          value: 'mx'
        }
      ]
    }
  },
  computed: {
    ...mapState('user', {
      user: 'user',
      kyc: 'kyc'
    })
  },
  watch: {
    save (value) {
      if (this.save) {
        this.savePersonalForm()
      }
    },
    dobMenu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  methods: {
    dobSave (date) {
      this.$refs.menu.save(date)
    },
    savePersonalForm () {
      if (this.$refs.personalForm.validate()) {
        const user = { ...this.user }
        const kyc = { ...this.kyc }
        if (this.permanentSameAsCurrentAddress) {
          user.permanentAddressDoorNumber = ''
          user.permanentAddressStreet = ''
          user.permanentAddressState = ''
          user.permanentAddressCity = ''
          user.permanentCountryName = ''
          user.permanentAddressPin = ''
        }
        const userDto = {
          user: user,
          pan: kyc.pan,
          aadhar: kyc.aadhar
        }
        Store.dispatch('user/saveUserProfileInformation', userDto).then(
          () => this.$emit('resetSave', true)
        )
        // if (this.mediaToSend !== null) {
        //   Store.dispatch('user/uploadProfilePic', this.mediaToSend)
        // }
      }
      this.$emit('resetSave', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/PersonalForm.vue